import { module as BaseModule } from "modujs";


export default class extends BaseModule {
  init() {
    // Only run on desktop (lg breakpoint: 1024px)

    if (window.innerWidth < 1024) {
      return;
    }

    // Get the title element
    this.titleElement = this.el.querySelector("[data-project-related-title]");
    if (!this.titleElement) {
      return;
    }

    // Store the original text
    this.originalTitle = this.titleElement.textContent.trim();

    // Get all related project links
    this.links = this.el.querySelectorAll("[data-project-related-link]");
    if (!this.links.length) {
      return;
    }

    // Add hover event listeners to each link
    this.links.forEach((link) => {
      link.addEventListener("mouseenter", this.handleMouseEnter.bind(this));
      link.addEventListener("mouseleave", this.handleMouseLeave.bind(this));
    });
  }

  handleMouseEnter(event) {
    const title = event.currentTarget.getAttribute("data-project-related-title");
    if (title) {
      this.titleElement.textContent = title;
    }
  }

  handleMouseLeave() {
    this.titleElement.textContent = this.originalTitle;
  }
}
